import type { PopularLink } from "@/constants/popular-links";

export const resolvePopularQuestions = (
  tenantQuestions: string[] | undefined,
): PopularLink[] => {
  return tenantQuestions?.map(question => ({ displayText: question })) ?? [];
};
